import React from 'react';

import { defaultRenderers } from 'components/Grid';
import { ColumnDefinition } from 'components/Grid/types';
import { TaskStatusOperator } from 'components/Grid/operators/Status';

import TaskDueDate from 'containers/TaskDetails/components/TaskDueDate';
import { StyledTaskChip } from 'containers/Tasks/components/TasksTable/styles';

import { TaskStatus } from 'utils/api/modules/tasks/tasks.constants';

import { withoutControls } from '../columns';
import { DueDateCell } from './styles';

const auditTasksColumns = [
  { field: 'name', headerName: 'Task name', nativeFilter: true },
  {
    field: 'assigned',
    headerName: 'Assigned to',
    renderCell: defaultRenderers.user,
    valueGetter: (value: unknown) => ({ value }),
    sortable: false,
  },
  {
    field: 'status',
    headerName: 'Status',
    renderCell: ({ value }: { value: TaskStatus }) => <StyledTaskChip status={value} />,
    filterOperators: TaskStatusOperator(),
    nativeFilter: true,
  },
  {
    field: 'dueDate',
    headerName: 'Due date',
    // No `showTime`: it keys red off an `overdue` status this endpoint never sends, muting every row.
    renderCell: ({ value, row }: { value: string; row: { status: TaskStatus } }) => (
      <DueDateCell>
        <TaskDueDate date={value} status={row.status} />
      </DueDateCell>
    ),
    sortable: false,
  },
] as unknown as ColumnDefinition[];

export const auditTasksCardColumns = auditTasksColumns;

export const auditTasksPageColumns = withoutControls(auditTasksColumns);
